import React from 'react';

const PaymentTypeSelect = ({sendData, setSendData, initialData, componentData, setComponentData,}) => {
  return (
    <div className={'solid-dyna-input'}>
      <label htmlFor="sendData__paymentType">نحوه پرداخت</label>
      <select
        className=""
        id={'sendData__paymentType'}
        onChange={(e) => setSendData({paymentType: e.target.value})}
        // ref={paymentTypeRef}
        value={sendData.paymentType}
        required
      >
        {/*<option value="" hidden>*/}
        {/*  نوع پرداخت*/}
        {/*</option>*/}
        <option
          value={"cacheAndBank"}
        >
          نقد و بانک
        </option>
        <option
          value={"debt"}
        >
          حساب دفتری
        </option>
      </select>
    </div>
  );
};

export default PaymentTypeSelect;
